module.exports = __webpack_public_path__ + "img/digitizing4.5fc5d094.png";